import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { useApplicationsStore } from '@/stores/applications.store'
import { ApplicationModel } from '@/models/application.model'
import { PaginatedResponse } from '@/models/templates/pagination.model'
import { admissionsService } from '@/services/admissionsService'

export function useApplications() {
  const { page, perPage, setPage, setPerPage } = useApplicationsStore()

  const queryKey = ['applications', page, perPage]

  const {
    data,
    error,
    isFetching,
    refetch,
    isPlaceholderData,
  } = useQuery<PaginatedResponse<ApplicationModel>, Error>({
    queryKey,
    queryFn: () => admissionsService.getApplicationsPage({ page, perPage }),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 2, // cache for 2 mins
    refetchOnWindowFocus: false,
  })

  const meta = data?.meta
  const applications = data?.data ?? []

  const goToPage = (p: number) => setPage(Math.max(1, p))
  const changePerPage = (pp: number) => {
    setPerPage(pp)
    setPage(1)
  }

  return {
    applications,
    meta,
    page,
    perPage,
    isFetching,
    error,
    refetch,
    goToPage,
    changePerPage,
    isPlaceholderData,
  }
}
